import classNames from 'classnames';
import { useLocale, useTranslations } from 'shared/hooks/i18n';
import Head from 'next/head';
import Image from 'next/image';
import { InterfaceLanguage } from 'types/enums';
import styles from './style.module.scss';

const TechWorks = () => {
  const t = useTranslations();
  const lang = useLocale();

  const socials = [
    {
      icon: <Image src='/icons/social/telegram.svg' width={24} height={24} alt='telegram' />,
      link: 'https://t.me/arbihunter',
      permissions: [InterfaceLanguage.English, InterfaceLanguage.Russian],
    },
    // uk telegram
    {
      icon: <Image src='/icons/social/telegram.svg' width={24} height={24} alt='telegram' />,
      link: 'https://t.me/ArbiHunterUkraine',
      permissions: [InterfaceLanguage.Ukranian],
    },
    {
      icon: <Image src='/icons/social/vk.svg' width={24} height={24} alt='vk' />,
      link: 'https://vk.com/arbihunter',
      permissions: [InterfaceLanguage.Russian, InterfaceLanguage.English],
    },
    {
      icon: <Image src='/icons/social/dzen.svg' width={24} height={24} alt='dzen' />,
      link: 'https://dzen.ru/arbihunter',
      permissions: [InterfaceLanguage.Russian, InterfaceLanguage.English],
    },
    {
      icon: <Image src='/icons/social/tiktok.svg' width={24} height={24} alt='tiktok' />,
      link: 'https://www.tiktok.com/@arbi_hunter?_t=8rUkBuBtFfm&_r=1',
      permissions: [InterfaceLanguage.Russian, InterfaceLanguage.English],
    },
    {
      icon: <Image src='/icons/social/instagram.svg' width={24} height={24} alt='instagram' />,
      link: 'https://www.instagram.com/arbihunter_ua?igsh=MTM3eWZ1a2J4OWN4aw%3D%3D&utm_source=qr',
      permissions: [
        InterfaceLanguage.Ukranian,
        InterfaceLanguage.Russian,
        InterfaceLanguage.English,
      ],
    },
    {
      icon: <Image src='/icons/social/vc.svg' width={24} height={24} alt='vc' />,
      link: 'https://vc.ru/u/3972302-arbihunter',
      permissions: [InterfaceLanguage.Russian, InterfaceLanguage.English],
    },
  ];

  const filteredByLanguageSocials = socials.filter((item) =>
    item.permissions.includes(lang as InterfaceLanguage),
  );

  return (
    <>
      <Head>
        <title>{`ArbiHunter | ${t('tech_works')}`}</title>
        <meta name='description' content={t('tech_works')} />
      </Head>
      <div className={styles.container}>
        <Image src='/icons/wrench.svg' width={96} height={96} alt='wrench' />
        <div className={styles.text}>
          <h1 className={styles.title}>{t('went_planning_tech_works', { time: '20:00 (UTC)' })}</h1>
          <p className={styles.description}>
            {t('at_the_moment_the_site_is_undergoing_technical_works')}
          </p>
        </div>
        <div
          className={classNames(styles.socialBlock, {
            [styles.socialBlock__disabled]: filteredByLanguageSocials.length === 0,
          })}>
          <p className={styles.socialBlock__text}>{t('ours_social_networks')}</p>
          <div className={styles.socialBlock__icons}>
            {filteredByLanguageSocials.map((item) => (
              <a
                key={item.link}
                href={item.link}
                className={styles.socialBlock__icon}
                target='_blank'
                rel='noopener noreferrer'>
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TechWorks;
